export function navigatorOverlayStatus(state = false, action) {
    switch (action.type) {
        case 'UPDATE_NAVIGATOR_OVERLAY':
            return action.overlayStatus

        default:
            return state
    }
}

export function navigatorStatus(state = false, action) {
    switch (action.type) {
        case 'UPDATE_NAVIGATOR_STATUS':
            return action.status

        default:
            return state
    }
}

export function navigator(state = {}, action) {
    switch(action.type) {
        case 'FETCH_NAVIGATOR_SUCCESS':
            return action.payload.data
        default:
            return state
    }
}